/* Custom element reconnects safely when Shopify reloads the section. */
if (!customElements.get('pwc-video')) {
  customElements.define('pwc-video', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const options = { signal: this._controller.signal };
      this._video = this.querySelector('video');
      this._button = this.querySelector('button');
      if (!this._video || !this._button) return;
      this._manualPause = false;
      this._visible = false;
      this._motion = matchMedia('(prefers-reduced-motion: reduce)');
      this._video.controls = false;
      this._button.hidden = false;
      this._sync = () => {
        const paused = this._video.paused;
        const label = paused ? (this.dataset.labelPlay || 'Play') : (this.dataset.labelPause || 'Pause');
        this._button.setAttribute('aria-label', label);
        this._button.querySelector('[data-video-label]').textContent = label;
        this._button.querySelector('[data-video-icon]').innerHTML = paused
          ? '<path d="M3 1.5v9l8-4.5z"/>'
          : '<path d="M2 1h3v10H2zm5 0h3v10H7z"/>';
      };
      this._play = () => this._video.play().catch(() => this._sync());
      this._button.addEventListener('click', () => {
        if (this._video.paused) { this._manualPause = false; this._play(); }
        else { this._manualPause = true; this._video.pause(); }
      }, options);
      this._video.addEventListener('play', this._sync, options);
      this._video.addEventListener('pause', this._sync, options);
      this._motion.addEventListener('change', () => {
        if (this._motion.matches) this._video.pause();
        else if (this._visible && !this._manualPause && !document.hidden) this._play();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this._video.pause();
        else if (this._visible && !this._manualPause && !this._motion.matches) this._play();
      }, options);
      this._observer = new IntersectionObserver(entries => {
        this._visible = entries[0].isIntersecting;
        if (this._visible && !this._manualPause && !this._motion.matches && !document.hidden) this._play();
        else if (!this._visible) this._video.pause();
      }, { threshold: .2 });
      this._observer.observe(this);
      this._sync();
    }
    disconnectedCallback() {
      this._observer?.disconnect();
      this._controller?.abort();
      this._video?.pause();
      this._controller = null;
    }
  });
}
